import React, { useState, useRef } from 'react';
import { Tabs, message } from 'antd';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
import moment from 'moment';
import { LocalPersistence } from '../../../../../factories';
import Loading from '../../../../Loading';
import DetailAdd from './GuaranteePaymentAdd/DetailAdd';
import AcceptedPaymentAdd from './GuaranteePaymentAdd/AcceptedPaymentAdd';
import PaymentAddressAdd from './GuaranteePaymentAdd/PaymentAddressAdd';
import { savePolicyGuaranteePayment } from '../../../../../services/policy';
import styles from './gpStyles.module.css';
import '@ui/ActionButtonsBar/styles.css';
const dateFormat = 'MM/DD/YYYY';
const formatTime = 'HH:mm';

const { TabPane } = Tabs;
const GPAdd = (props: any) => {
  const [addLoading, setAddLoading] = useState(false);
  const [disabledStatus, setDisabledStatus] = useState(true);
  const detailAddRef = useRef<any>();
  const accPayAddRef = useRef<any>();
  const payAddAddRef = useRef<any>();
  const [dateValidation, setDateValidation] = useState<boolean>(false);
  const addSave = () => {
    Promise.all([
      detailAddRef.current.detailsForm.validateFields(),
      accPayAddRef.current.aceeptedPaymentForm.validateFields(),
      payAddAddRef.current.paymentAddressForm.validateFields(),
    ])
      .then(async (value: Array<any>) => {
        const addObj: any = {};
        detailAddRef.current.dayValueList.forEach((item: any) => {
          addObj[item.label] = '' + item.value;
        });

        const detailsValue = value[0];
        addObj.startdate = detailsValue.startdate
          ? moment(detailsValue.startdate).format(dateFormat)
          : '';
        addObj.enddate = detailsValue.enddate
          ? moment(detailsValue.enddate).format(dateFormat)
          : '';
        addObj.policyname = detailsValue.policyname || '';
        addObj.policycode = detailsValue.policycode || '';
        addObj.policytype = detailsValue.policytype || '';
        addObj.guaranteetype = detailsValue.guaranteetype || '';
        addObj.roomtypecode = detailsValue.roomtypecode || '';
        addObj.nonrefundable = detailsValue.nonrefundable || '';
        addObj.holdtime =
          (detailsValue.holdtime &&
            moment(detailsValue.holdtime).format(formatTime)) ||
          '';
        addObj.retribution = detailsValue.retribution || '';
        addObj.chargetype = detailsValue.chargetype || '';
        if (addObj.chargetype === 'Amount') {
          addObj.chargeamount = detailsValue.charge || '';
          addObj.currency = detailsValue.currency || '';
        } else if (addObj.chargetype === 'Percent') {
          addObj.chargepercent = detailsValue.charge || '';
        } else if (addObj.chargetype === 'Nights') {
          addObj.chargenights = detailsValue.charge || '';
        }
        addObj.timeunit = detailsValue.timeunit || '';
        addObj.noofunits = detailsValue.noofunits || '';
        addObj.calculationmethod = detailsValue.calculationmethod || '';
        addObj.descriptions = [];
        Object.keys(detailsValue).forEach((item) => {
          item.indexOf('descript-') >= 0 &&
            addObj.descriptions.push({ text: detailsValue[item] || '' });
        });
        const accPayValue = value[1];
        let accPayArr: any = [];
        const maxcapacityId = Object.keys(accPayValue).map((item) => {
          return item.split('-')[1];
        });
        Array.from(new Set(maxcapacityId)).forEach((item) => {
          accPayArr.push({
            cardtype: accPayValue['cardtype-' + item] || '',
            acceptedforguarnatee:
              accPayValue['acceptedforguarnatee-' + item] || '',
            paymenttype: accPayValue['paymenttype-' + item] || '',
            description: accPayValue['description-' + item] || '',
            usefordeposit: accPayValue['usefordeposit-' + item] || '',
            useforpayment: accPayValue['useforpayment-' + item] || '',
          });
        });
        addObj.acceptedpayments = accPayArr;

        const payAddValue = value[2];
        let payAddArr: any = [];

        const payAddId: any = [];
        const addressId: any = [];
        Object.keys(payAddValue).forEach((item) => {
          if (item.split('-')[1].indexOf('**') > 0) {
            addressId.push(item.split('-')[1]);
          } else {
            payAddId.push(item.split('-')[1]);
          }
        });

        Array.from(new Set(payAddId)).forEach((item) => {
          const addresslineArr: any = {};
          const addresslineId = addressId.filter((item1: any) => {
            return item1.startsWith(item + '**');
          });
          addresslineId.forEach((addId: any, index: number) => {
            addresslineArr['addressline' + (index + 1)] =
              payAddValue['address-' + addId];
          });
          payAddArr.push({
            name: payAddValue['addname-' + item] || '',
            type: payAddValue['type-' + item] || '',
            pobox: payAddValue['pobox-' + item] || '',
            city: payAddValue['city-' + item] || '',
            state: payAddValue['state-' + item] || '',
            country: payAddValue['country-' + item] || '',
            postalcode: payAddValue['postalcode-' + item] || '',
            ...addresslineArr,
          });
        });

        addObj.paymentaddress = payAddArr;
        const get_session = new LocalPersistence('session');
        const session: any = await get_session.getSessionPersistence();
        const params = {
          supplier: session.supplier,
          propertyId: session.propertyId,
          property: {
            policies: {
              guaranteepolicy: [
                {
                  ...addObj,
                },
              ],
            },
          },
        };
        setAddLoading(true);
        savePolicyGuaranteePayment(params).then(
          (res) => {
            setAddLoading(false);
            if (res.result.success) {
              cancelHandle();
            } else {
              message.error({
                content: res?.error[0]?.message || 'operation failed',
              });
            }
          },
          (err) => {
            message.error({
              content: err?.message || err?.error[0]?.message,
            });
            setAddLoading(false);
          }
        );
      })
      .catch(() => {
        // message.error({
        //   content: 'Check all the fields please.',
        // });
      });
  };
  const cancelHandle = async () => {
    detailAddRef.current.detailsForm.resetFields();
    accPayAddRef.current.aceeptedPaymentForm.resetFields();
    payAddAddRef.current.paymentAddressForm.resetFields();
    detailAddRef.current.restoreErr();
    accPayAddRef.current.restoreErr();
    payAddAddRef.current.restoreErr();
    props.cancelEditable();
    await props.getPoliciesData('GuaranteePayment');
  };

  const validateFieldsError = (isDisabled?: boolean) => {
    if (isDisabled) {
      setDisabledStatus(isDisabled);
      return;
    }
    Promise.all([
      detailAddRef.current.detailsForm.validateFields(),
      accPayAddRef.current.aceeptedPaymentForm.validateFields(),
      payAddAddRef.current.paymentAddressForm.validateFields(),
    ])
      .then(() => {
        if (!dateValidation) {
          setDisabledStatus(false);
        } else {
          setDisabledStatus(true);
        }
      })
      .catch(() => {
        const detailErrNum = detailAddRef?.current?.detailsForm
          ?.getFieldsError()
          ?.filter(({ errors }: { errors: any }) => errors.length).length;
        const accPayErrNum = accPayAddRef?.current?.aceeptedPaymentForm
          ?.getFieldsError()
          ?.filter(({ errors }: { errors: any }) => errors.length).length;
        const payAddErrNum = payAddAddRef?.current?.paymentAddressForm
          ?.getFieldsError()
          ?.filter(({ errors }: { errors: any }) => errors.length).length;
        const errTotalNum = detailErrNum + accPayErrNum + payAddErrNum;

        if (errTotalNum === 0 && !dateValidation) {
          setDisabledStatus(false);
        } else {
          setDisabledStatus(true);
        }
      });
  };

  if (addLoading) return <Loading type="large" />;
  return (
    <>
      <Tabs defaultActiveKey={props.activeTabKey}>
        <TabPane
          tab="Detail"
          key="Detail"
          forceRender={true}
        >
          <DetailAdd
            className={styles.cardMargin}
            ref={detailAddRef}
            cancellationDetails={props.cancellationDetails}
            setValidateDate={setDateValidation}
            validateDate={dateValidation}
            validateFieldsError={validateFieldsError}
          />
        </TabPane>
        <TabPane
          tab="Accepted Payment"
          key="AcceptedPayment"
          forceRender={true}
        >
          <AcceptedPaymentAdd
            className={styles.cardMargin}
            ref={accPayAddRef}
            validateFieldsError={validateFieldsError}
          />
        </TabPane>
        <TabPane
          tab="Payment Address"
          key="PaymentAddress"
          forceRender={true}
        >
          <PaymentAddressAdd
            className={styles.cardMargin}
            ref={payAddAddRef}
            validateFieldsError={validateFieldsError}
          />
        </TabPane>
      </Tabs>
      <ActionButtonsBar
        onCancel={cancelHandle}
        onSave={addSave}
        disabledSave={disabledStatus}
        warningMsg={true}
      />
    </>
  );
};
export default GPAdd;
